import type {
  Photographer,
  PhotographerState,
  PhotographerTier,
} from '../types';

const NAMES = [
  'Ava Moreau',
  'Liam Rossi',
  'Sofia Marín',
  'Noah Bergström',
  'Mia Nakamura',
  'Ethan Okafor',
  'Chiara Bruno',
  'Lucas Silva',
  'Amara Diallo',
  'Yuki Tanaka',
  'Elena Petrova',
  'Marco Colombo',
];

const PLACES: [string, string][] = [
  ['London', 'United Kingdom'],
  ['Milan', 'Italy'],
  ['Madrid', 'Spain'],
  ['Stockholm', 'Sweden'],
  ['Tokyo', 'Japan'],
  ['Lagos', 'Nigeria'],
  ['Rome', 'Italy'],
  ['São Paulo', 'Brazil'],
  ['Dakar', 'Senegal'],
  ['Osaka', 'Japan'],
  ['Moscow', 'Russia'],
  ['Turin', 'Italy'],
];

const STATE_CYCLE: PhotographerState[] = [
  'valid',
  'valid',
  'valid',
  'to_fix',
  'valid',
  'banned-temporarily',
  'valid',
  'valid',
  'invalid',
  'valid',
  'to_fix',
  'valid',
];

export const photographersMock: Photographer[] = NAMES.map((name, i) => {
  const [city, country] = PLACES[i % PLACES.length]!;
  const state = STATE_CYCLE[i % STATE_CYCLE.length]!;
  const tier: PhotographerTier = i % 3 === 0 ? 'gold' : 'basic';
  const handle = name.toLowerCase().replace(/[^a-z]+/g, '');
  const hasPhotos = i < NAMES.length - 2;

  return {
    id: `photographer-${i + 1}`,
    createdAt: new Date(Date.UTC(2020, i, 15)).toISOString(),
    name,
    avatar: `https://i.pravatar.cc/150?img=${(i % 70) + 1}`,
    city,
    country,
    state,
    tier,
    warningCount: state === 'to_fix' ? 1 : 0,
    banCount: state.startsWith('banned-') ? 1 : 0,
    totalPhotos: hasPhotos ? 8 + i * 4 : 0,
    totalBest: hasPhotos ? i % 4 : 0,
    totalDaily: hasPhotos ? i % 3 : 0,
    biography: `${name} is a ${tier === 'gold' ? 'Gold' : 'contributing'} PhotoVogue photographer based in ${city}, ${country}.`,
    websites: [`https://${handle}.example`],
  };
});
